import * as config from './../../config';

export const processNames = {
  UPDATE_PASSWORD: `${config.prefix}UPDATE_PASSWORD`,
  UPDATE_PROFILE: `${config.prefix}UPDATE_PROFILE`,
  RESEND_CONFIRMATION_EMAIL: `${config.prefix}RESEND_CONFIRMATION_EMAIL`,
  SEND_CODE: `${config.prefix}SEND_CODE`,
  SUBMIT_CODE: `${config.prefix}SUBMIT_CODE`,
  UNBIND_FB: `${config.prefix}UNBIND_FB`,
};